var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("tr", [
    _c(
      "th",
      {
        staticClass:
          "kpi-benchmarks-table__section kpi-benchmarks-table__section--pre-purchase-metrics",
        attrs: { colspan: "9" }
      },
      [
        _vm._v("\n    " + _vm._s(_vm.title) + "\n    "),
        _c("span", {
          staticClass: "benchmark-anchor",
          attrs: { id: _vm.anchor }
        })
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }